import { render, staticRenderFns } from "./ReturnsCenter.vue?vue&type=template&id=7e5f555c&"
import script from "./ReturnsCenter.vue?vue&type=script&lang=js&"
export * from "./ReturnsCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports